module.exports = __webpack_public_path__ + "static/media/prawnaglioolionew.24ecb7d3.jpeg";